<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        {{ saveType == "update" ? "Update " : "Add New " }} Route Status
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select
              :items="computedStatusTemplate"
              label="Set Route Status"
              v-model="selected"
              item-value="name"
              return-object
            >
              <template slot="selection" slot-scope="{ item }">
                {{ item.name }}
              </template>
              <template slot="item" slot-scope="{ item }">
                {{ item.name }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea
              outlined
              name="input-7-4"
              label="Remarks"
              value=""
              v-model="remarks"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="text-right">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="save">Save</v-btn>
        <v-btn color="primary" text @click="close"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "UpdateRouteStatusDialog",
    props: {
      dialog: Boolean,
      routeId: Number,
      routeCurrentStatus: String,
      routeType: String,
      subRouteIndex: Number,
      parentRouteId: String,
      saveType: String,
      currentRouteStatus: Object,
      statusTemplate: Array,
    },
    data() {
      return {
        selected: "",
        remarks: "",
        subroute_status_template: [],
      };
    },
    methods: {
      ...mapActions([
        "fetchRouteStatuses",
        "addRouteStatus",
        "addSubRouteStatus",
        "addChildSubRouteStatus",
      ]),
      close() {
        this.selected = "";
        this.$emit("closeDialog", false);
      },
      save() {
        if (this.routeType == "mainroute") {
          this.addRouteStatus({
            route_id: this.routeId,
            status: this.selected,
          });
        } else {
          let reqBody = {
            route_id: this.routeId,
            status: this.selected,
            remarks: this.remarks,
            save_type: this.saveType,
            previous_status_id:
              this.saveType == "update" ? this.currentRouteStatus.id : null,
          };

          if (this.routeType == "secondaryroute") {
            reqBody.routeType = this.routeType;

            this.addSubRouteStatus(reqBody)
              .then((result) => {
                this.$emit("addedStatus", result);
              })
              .catch((err) => console.log(err));
          } else {
            reqBody = Object.assign(reqBody, {
              routeType: this.routeType,
              subRouteIndex: this.subRouteIndex,
              route_index: this.subRouteIndex,
              container: this.parentRouteId,
            });

            this.addChildSubRouteStatus(reqBody)
              .then((res) => {
                this.$emit("addedStatus", res);
              })
              .catch((err) => console.log(err));
          }
        }

        this.close();
      },
    },
    watch: {
      dialog: function() {
        if (this.dialog) {
          this.subroute_status_template = this.statusTemplate.map(
            (status) => status.status
          );

          this.selected = this.routeCurrentStatus;
          if (this.saveType == "update") {
            const index = this.allRouteStatuses.findIndex(
              (e) => e.id === this.currentRouteStatus.status.id
            );

            this.selected = this.allRouteStatuses[index];
            this.remarks = this.currentRouteStatus.remarks;
          }
        } else {
          this.selected = "";
        }
      },
    },
    created() {
      this.fetchRouteStatuses();
    },
    computed: {
      ...mapGetters(["allRouteStatuses"]),
      computedStatusTemplate() {
        return this.subroute_status_template;
      },
    },
  };
</script>

<style></style>
